module.exports = __webpack_public_path__ + "media/images/svg-icon/user-07db70a765b13557c43ab2444227c36f.svg";